// @flow
import React from 'react';
import DonorsChoose from 'action-opps-donors-choose.svg';
import Kiva from 'action-opps-kiva.svg';
import Nycparks from 'action-opps-nycparks.svg';
import Eventbrite from 'action-opps-eventbrite.svg';
import GlobalGiving from 'action-opps-global-giving.svg';
import VolunteerMatch from 'action-opps-volunteermatch.svg';
import MoveOn from 'action-opps-move-on.svg';
import PointsOfLight from 'action-opps-points-of-light.svg';
import Icon from 'components/Icon';

const getIconComponent = name => {
  switch (name) {
    case 'kiva':
      return Kiva;
    case 'nycparks':
      return Nycparks;
    case 'eventbrite':
      return Eventbrite;
    case 'global-giving':
      return GlobalGiving;
    case 'volunteermatch':
      return VolunteerMatch;
    case 'move-on':
      return MoveOn;
    case 'points-of-light':
      return PointsOfLight;
    case 'donors-choose':
    default:
      return DonorsChoose;
  }
};

const VolopsIcon = ({ name, ...props }: { name: string }) => (
  <Icon component={getIconComponent(name)} {...props} />
);

export default VolopsIcon;
